/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Yes_ButtonInputs */

const en_editor_yes_button = /** @type {(inputs: Editor_Yes_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes`)
};

const fr_editor_yes_button = /** @type {(inputs: Editor_Yes_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui`)
};

const de_editor_yes_button = /** @type {(inputs: Editor_Yes_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja`)
};

const it_editor_yes_button = /** @type {(inputs: Editor_Yes_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SÌ`)
};

const ru_editor_yes_button = /** @type {(inputs: Editor_Yes_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Да`)
};

const es_editor_yes_button = /** @type {(inputs: Editor_Yes_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí`)
};

const zh_cn2_editor_yes_button = /** @type {(inputs: Editor_Yes_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`是的`)
};

const ja_editor_yes_button = /** @type {(inputs: Editor_Yes_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい`)
};

const hi_editor_yes_button = /** @type {(inputs: Editor_Yes_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हाँ`)
};

const pt_pt2_editor_yes_button = /** @type {(inputs: Editor_Yes_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim`)
};

/**
* | output |
* | --- |
* | "Yes" |
*
* @param {Editor_Yes_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_yes_button = /** @type {((inputs?: Editor_Yes_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Yes_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_editor_yes_button(inputs)
	if (locale === "de") return de_editor_yes_button(inputs)
	if (locale === "it") return it_editor_yes_button(inputs)
	if (locale === "ru") return ru_editor_yes_button(inputs)
	if (locale === "es") return es_editor_yes_button(inputs)
	if (locale === "zh-CN") return zh_cn2_editor_yes_button(inputs)
	if (locale === "ja") return ja_editor_yes_button(inputs)
	if (locale === "hi") return hi_editor_yes_button(inputs)
	if (locale === "pt-PT") return pt_pt2_editor_yes_button(inputs)
	return en_editor_yes_button(inputs)
});